
/**
 * 트윗 태그 정보
 */
export type TweetCreateRequestMetadataTags = {
  hashtagIds?: string[];
};
